import { IServiceDto } from "../../../types/Services.types";

export interface IServiceFormInput extends Omit<IServiceDto, "id"> {}

export const emptyServiceForm: IServiceFormInput = {
	createdDate: new Date(),
	createdBy: "",
	description: "",
	system: "",
	parts: [],
	duration: 0,
};
